import { RETRACED_COMPANY_ID } from '../../../../companies/constants.js';
import {
  ENTITY_HISTORY_ENTITY_TYPES,
  ENTITY_HISTORY_EVENT_TYPES,
  ENTITY_HISTORY_TABLE,
} from '../../../../entity-history/index.js';

const entriesOf = (eventTypes: string[]): string => `
        FROM ${ENTITY_HISTORY_TABLE}
       WHERE ${ENTITY_HISTORY_TABLE}.entity_type = '${ENTITY_HISTORY_ENTITY_TYPES.DOCUMENT_TYPE}'
         AND ${ENTITY_HISTORY_TABLE}.entity_id = dt.id
         AND ${ENTITY_HISTORY_TABLE}.by_company_id = '${RETRACED_COMPANY_ID}'
         AND ${ENTITY_HISTORY_TABLE}.event_type IN (${eventTypes.map(type => `'${type}'`).join(', ')})`;

/**
 * The type's creator and last editor, from `DOCUMENT_TYPE_HISTORY_JOINS`.
 * The table keeps no actor columns: the creator is its `DOCUMENT_TYPE`
 * `CREATED` entry and the last editor its newest `CREATED` or `UPDATED` one
 * (the creation itself until the type is first edited, as the columns had it).
 */
export const DOCUMENT_TYPE_ACTOR_COLUMNS = `creator.created_by_user_id,
       last_editor.created_by_user_id AS updated_by_user_id,
       last_editor.created_by_user_name AS updated_by_user_name`;

/**
 * The creator and last editor as lateral joins on `document_types`, aliased
 * `dt`. Both pin `by_company_id` to Retraced's own, so each is one descent of
 * the history's `(entity_type, entity_id, by_company_id, id)` index.
 */
export const DOCUMENT_TYPE_HISTORY_JOINS = `
     LEFT JOIN LATERAL (
       SELECT ${ENTITY_HISTORY_TABLE}.created_by_user_id${entriesOf([ENTITY_HISTORY_EVENT_TYPES.CREATED])}
        ORDER BY ${ENTITY_HISTORY_TABLE}.id
        LIMIT 1
     ) creator ON TRUE
     LEFT JOIN LATERAL (
       SELECT ${ENTITY_HISTORY_TABLE}.created_by_user_id,
              ${ENTITY_HISTORY_TABLE}.created_by_user_name${entriesOf([ENTITY_HISTORY_EVENT_TYPES.CREATED, ENTITY_HISTORY_EVENT_TYPES.UPDATED])}
        ORDER BY ${ENTITY_HISTORY_TABLE}.id DESC
        LIMIT 1
     ) last_editor ON TRUE`;
